export default "__VITE_ASSET__a3146e85__"